<div class="modal-header">
  <h3 class="modal-title">Editar categoría</h3>
  <button type="button" class="close text-primary" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  @if (filename) {
    <div class="filename text-truncate mb-3" [title]="filename">{{ filename }}</div>
  }
  <div class="form-group">
    <label>Categoría <span class="text-danger">*</span></label>
    <select
      class="form-control style-asunto"
      name="category"
      [(ngModel)]="selectedCategory"
      (ngModelChange)="onCategoryChange()"
      >
      <option [ngValue]="''" disabled>Seleccione categoría</option>
      @for (opt of categories; track opt.id) {
        <option [ngValue]="opt.id">{{ opt.name }}</option>
      }
    </select>
  </div>
  @if (selectedCategory === 'otro') {
    <div class="form-group">
      <label>Nombre de la categoría <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control style-asunto"
        name="categoryother"
        placeholder="Nombre de la categoría"
        [(ngModel)]="selectedCategoryOther"
        >
    </div>
  }
  @if (successMessage) {
    <ngb-alert class="mt-2" type="success" (close)="successMessage = ''">{{ successMessage }}</ngb-alert>
  }
  @if (errorMessage) {
    <ngb-alert class="mt-2" type="danger" (close)="errorMessage = ''">{{ errorMessage }}</ngb-alert>
  }
  <div class="form-group mb-0">
    <div class="row">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-outline-dark rounded-pill font-weight-bold" style="width: 120px;"
          (click)="activeModal.dismiss()" [disabled]="loading">
          Cerrar
        </button>
        <button type="button"
          class="btn btn-outline-primary rounded-pill text-dark font-weight-bold mr-2"
          style="width: 120px;"
          [disabled]="loading || !canSave"
          (click)="save()"
          >
          @if (loading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!loading) {
            <span>Guardar</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
